import { ChartConfig } from '@/components/ui/chart';

export const CHART_COLORS = {
  lifecycleRevenueBar: 'hsl(var(--chart-2))',
  flowsRevenueBar: 'hsl(var(--chart-1))',
  contextualLine: 'hsl(var(--chart-1))',
  metaLine: 'hsl(var(--chart-2))',
  tiktokLine: 'hsl(var(--chart-5))',
  snapchatLine: 'hsl(var(--chart-4))',
  muted: 'hsl(var(--muted))',
  metaPageViewEMQScore: '#475569',
  metaViewContentEMQScore: '#A78BFA',
  metaAddToCartEMQScore: '#6EE7B7',
  metaInitiateCheckoutEMQScore: '#FB7185',
  metaAddPaymentInfoEMQScore: '#FBBF24',
  metaPurchaseEMQScore: '#22D3EE',
  metaLeadEMQScore: '#0284C7'
} as const;

export const METRIC_TYPES = {
  LIFECYCLE_REVENUE: 'Influenced Revenue',
  FLOWS_REVENUE: 'Direct Revenue',
  TOTAL_ROI: 'Total ROI',
  ANON_VISITORS_RECOGNIZED: 'Anon Visitors Recognized',
  CONTEXTUAL_EVENTS: 'Contextual Server Events',
  META_EVENTS: 'Meta Pixel Events',
  TIKTOK_EVENTS: 'TikTok Pixel Events',
  SNAPCHAT_EVENTS: 'Snapchat Pixel Events',
  META_PAGE_VIEW_EMQ_SCORE: 'Page View',
  META_VIEW_CONTENT_EMQ_SCORE: 'View Content',
  META_ADD_TO_CART_EMQ_SCORE: 'Add to Cart',
  META_ADD_PAYMENT_INFO_EMQ_SCORE: 'Add Payment Info',
  META_INITIATE_CHECKOUT_EMQ_SCORE: 'Initiate Checkout',
  META_PURCHASE_EMQ_SCORE: 'Purchase',
  META_LEAD_EMQ_SCORE: 'Lead'
} as const;

export type MetricType = (typeof METRIC_TYPES)[keyof typeof METRIC_TYPES];

export const CHART_CONFIG: ChartConfig = {
  [METRIC_TYPES.LIFECYCLE_REVENUE]: {
    label: 'Influenced Revenue',
    color: CHART_COLORS.lifecycleRevenueBar
  },
  [METRIC_TYPES.FLOWS_REVENUE]: {
    label: 'Direct Revenue',
    color: CHART_COLORS.flowsRevenueBar
  },
  [METRIC_TYPES.TOTAL_ROI]: {
    label: 'Total ROI',
    color: CHART_COLORS.contextualLine
  },
  [METRIC_TYPES.ANON_VISITORS_RECOGNIZED]: {
    label: 'Anon Visitors Recognized',
    color: CHART_COLORS.contextualLine
  },
  [METRIC_TYPES.CONTEXTUAL_EVENTS]: {
    label: 'Contextual',
    color: CHART_COLORS.contextualLine
  },
  [METRIC_TYPES.META_EVENTS]: {
    label: 'Meta',
    color: CHART_COLORS.metaLine
  },
  [METRIC_TYPES.TIKTOK_EVENTS]: {
    label: 'TikTok',
    color: CHART_COLORS.tiktokLine
  },
  [METRIC_TYPES.SNAPCHAT_EVENTS]: {
    label: 'Snapchat',
    color: CHART_COLORS.snapchatLine
  },
  [METRIC_TYPES.META_PAGE_VIEW_EMQ_SCORE]: {
    label: 'Page View',
    color: CHART_COLORS.metaPageViewEMQScore
  },
  [METRIC_TYPES.META_VIEW_CONTENT_EMQ_SCORE]: {
    label: 'View Content',
    color: CHART_COLORS.metaViewContentEMQScore
  },
  [METRIC_TYPES.META_ADD_TO_CART_EMQ_SCORE]: {
    label: 'Add to Cart',
    color: CHART_COLORS.metaAddToCartEMQScore
  },
  [METRIC_TYPES.META_INITIATE_CHECKOUT_EMQ_SCORE]: {
    label: 'Initiate Checkout',
    color: CHART_COLORS.metaInitiateCheckoutEMQScore
  },
  [METRIC_TYPES.META_ADD_PAYMENT_INFO_EMQ_SCORE]: {
    label: 'Add Payment Info',
    color: CHART_COLORS.metaAddPaymentInfoEMQScore
  },
  [METRIC_TYPES.META_PURCHASE_EMQ_SCORE]: {
    label: 'Purchase',
    color: CHART_COLORS.metaPurchaseEMQScore
  },
  [METRIC_TYPES.META_LEAD_EMQ_SCORE]: {
    label: 'Lead',
    color: CHART_COLORS.metaLeadEMQScore
  }
} as const;

export const eventMetrics = [
  METRIC_TYPES.CONTEXTUAL_EVENTS,
  METRIC_TYPES.META_EVENTS,
  METRIC_TYPES.TIKTOK_EVENTS,
  METRIC_TYPES.SNAPCHAT_EVENTS
];

export const metaEmqMetrics = [
  METRIC_TYPES.META_PAGE_VIEW_EMQ_SCORE,
  METRIC_TYPES.META_VIEW_CONTENT_EMQ_SCORE,
  METRIC_TYPES.META_ADD_TO_CART_EMQ_SCORE,
  METRIC_TYPES.META_INITIATE_CHECKOUT_EMQ_SCORE,
  METRIC_TYPES.META_ADD_PAYMENT_INFO_EMQ_SCORE,
  METRIC_TYPES.META_PURCHASE_EMQ_SCORE,
  METRIC_TYPES.META_LEAD_EMQ_SCORE
];

export const CHART_GRID_COLOR = 'hsl(var(--border))';
export const CHART_TICK_COLOR = 'hsl(var(--muted-foreground))';
